/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionGrantFragmentDoc } from "../../../../mutations/collections.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AddHexesToCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  appUserProjectIds:
    | ReadonlyArray<Types.Scalars["HexId"]["input"]>
    | Types.Scalars["HexId"]["input"];
  viewerProjectIds:
    | ReadonlyArray<Types.Scalars["HexId"]["input"]>
    | Types.Scalars["HexId"]["input"];
  editorProjectIds:
    | ReadonlyArray<Types.Scalars["HexId"]["input"]>
    | Types.Scalars["HexId"]["input"];
  ownerProjectIds:
    | ReadonlyArray<Types.Scalars["HexId"]["input"]>
    | Types.Scalars["HexId"]["input"];
  noAddedGrantProjectIds:
    | ReadonlyArray<Types.Scalars["HexId"]["input"]>
    | Types.Scalars["HexId"]["input"];
}>;

export type AddHexesToCollectionMutation = {
  readonly __typename: "Mutation";
  readonly addHexesToCollection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
  };
};

export type AddToCollectionDialogFragment = {
  readonly __typename: "Collection";
  readonly id: c.CollectionId;
  readonly name: string;
  readonly emoji: string | null;
  readonly description: string | null;
  readonly collectionGrants: ReadonlyArray<{
    readonly __typename: "CollectionGrant";
    readonly id: c.CollectionGrantId;
    readonly role: Types.CollectionRole;
    readonly holder:
      | {
          readonly __typename: "Group";
          readonly groupId: c.GroupId;
          readonly groupName: string;
        }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        }
      | {
          readonly __typename: "User";
          readonly name: string | null;
          readonly email: string;
          readonly active: boolean;
          readonly imageUrl: string | null;
          readonly orgRole: Types.OrgRole;
          readonly userId: c.UserId;
        };
  }>;
  readonly collectionHexLinks: ReadonlyArray<{
    readonly __typename: "CollectionHexLink";
    readonly id: c.CollectionHexLinkId;
    readonly safeOrUnknownHex:
      | { readonly __typename: "Hex"; readonly id: c.HexId }
      | { readonly __typename: "UnknownHex"; readonly id: c.HexId };
  }>;
};

export const AddToCollectionDialogFragmentDoc = /*#__PURE__*/ gql`
  fragment AddToCollectionDialogFragment on Collection {
    id
    name
    emoji
    description
    collectionGrants {
      id
      ...CollectionGrantFragment
    }
    collectionHexLinks {
      ... on CollectionHexLink {
        id
        safeOrUnknownHex {
          ... on Hex {
            id
          }
          ... on UnknownHex {
            id
          }
        }
      }
    }
  }
  ${CollectionGrantFragmentDoc}
`;
export const AddHexesToCollectionDocument = /*#__PURE__*/ gql`
  mutation AddHexesToCollection(
    $collectionId: CollectionId!
    $appUserProjectIds: [HexId!]!
    $viewerProjectIds: [HexId!]!
    $editorProjectIds: [HexId!]!
    $ownerProjectIds: [HexId!]!
    $noAddedGrantProjectIds: [HexId!]!
  ) {
    addHexesToCollection(
      collectionId: $collectionId
      appUserProjectIds: $appUserProjectIds
      viewerProjectIds: $viewerProjectIds
      editorProjectIds: $editorProjectIds
      ownerProjectIds: $ownerProjectIds
      noAddedGrantProjectIds: $noAddedGrantProjectIds
    ) {
      id
    }
  }
`;
export type AddHexesToCollectionMutationFn = Apollo.MutationFunction<
  AddHexesToCollectionMutation,
  AddHexesToCollectionMutationVariables
>;

/**
 * __useAddHexesToCollectionMutation__
 *
 * To run a mutation, you first call `useAddHexesToCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHexesToCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHexesToCollectionMutation, { data, loading, error }] = useAddHexesToCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      appUserProjectIds: // value for 'appUserProjectIds'
 *      viewerProjectIds: // value for 'viewerProjectIds'
 *      editorProjectIds: // value for 'editorProjectIds'
 *      ownerProjectIds: // value for 'ownerProjectIds'
 *      noAddedGrantProjectIds: // value for 'noAddedGrantProjectIds'
 *   },
 * });
 */
export function useAddHexesToCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddHexesToCollectionMutation,
    AddHexesToCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddHexesToCollectionMutation,
    AddHexesToCollectionMutationVariables
  >(AddHexesToCollectionDocument, options);
}
export type AddHexesToCollectionMutationHookResult = ReturnType<
  typeof useAddHexesToCollectionMutation
>;
export type AddHexesToCollectionMutationResult =
  Apollo.MutationResult<AddHexesToCollectionMutation>;
export type AddHexesToCollectionMutationOptions = Apollo.BaseMutationOptions<
  AddHexesToCollectionMutation,
  AddHexesToCollectionMutationVariables
>;
